import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'form-value-button',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './form-value-button.component.html',
  styleUrl: './form-value-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormValueButtonComponent {
  subtitle = input.required<string>();
  value = input('');
  transparent = input(false);
  onClick = output<void>();
}
